import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { useCallback } from 'react';
import { CloseIcon } from '../../icons/closeIcon';
import { clearFooterAlert } from '../../redux/actions/footerAlertActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { YELLOW_COLOR } from '../../styles/colors';
import { lightTheme } from '../../styles/materialTheme';
const CONTAINER_CSS = css `
  background-color: ${YELLOW_COLOR};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 8px;
`;
export const FooterAlertContainer = () => {
    const dispatch = useAppDispatch();
    const footerAlertMessage = useAppSelector((state) => state.footerAlert.alert?.message);
    const onClose = useCallback(() => {
        dispatch(clearFooterAlert());
    }, [dispatch]);
    if (!footerAlertMessage) {
        return null;
    }
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: lightTheme, children: _jsxs("aside", { css: CONTAINER_CSS, "aria-label": 'Alert', children: [_jsx("span", { children: footerAlertMessage }), _jsx(IconButton, { title: 'Close Alert', size: 'small', onClick: onClose, color: 'primary', children: _jsx(CloseIcon, {}) })] }) }) }));
};
